/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ActionSet64Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 64, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ActionSet64Icon"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M32.0654 25.752C32.1871 25.539 32.4461 25.4462 32.6758 25.5322C32.905 25.6184 33.0381 25.8575 32.9902 26.0977L32.2295 29.9023C32.1679 30.2116 32.4044 30.5 32.7197 30.5H36.5C36.6782 30.5 36.8432 30.5949 36.9326 30.749C37.022 30.9031 37.0229 31.0934 36.9346 31.248L32.9346 38.248C32.8129 38.461 32.5539 38.5538 32.3242 38.4678C32.095 38.3816 31.9619 38.1425 32.0098 37.9023L32.7705 34.0977C32.8321 33.7884 32.5956 33.5 32.2803 33.5H28.5C28.3218 33.5 28.1568 33.4051 28.0674 33.251C27.978 33.0969 27.9771 32.9066 28.0654 32.752L32.0654 25.752Z"
              stroke="currentColor"
              strokeLinejoin="round"
            />
            <path
              opacity="0.7"
              d="M44.7361 28.5641L35.2837 19.6092C33.7226 18.1303 31.2774 18.1303 29.7163 19.6092L20.2639 28.5641C18.6395 30.103 18.5719 32.668 20.1131 34.2903L29.5655 44.2402C31.1613 45.9199 33.8387 45.9199 35.4345 44.2402L44.8869 34.2903C46.4281 32.668 46.3605 30.103 44.7361 28.5641Z"
              stroke="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ActionSet64Icon.tags = ['power', 'electricity', 'energy', 'bolt', 'lightning'];

ActionSet64Icon.category = '64x64 (Add panel)';

ActionSet64Icon.iconSize = 64;
